import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "input-form-group" }
const _hoisted_2 = ["data-error"]
const _hoisted_3 = ["type", "name", "maxlength", "placeholder", "readonly", "pattern", "inputmode"]

import { computed, PropType, ref, WritableComputedRef } from 'vue';
  import LabelComponent from './LabelComponent.vue';
  import { TheMask } from './TheMask';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'InputComponent',
  props: {
    value: {
      type: String,
      default: '',
    },
    type: {
      type: String as PropType<
        | 'text'
        | 'email'
        | 'datepicker'
        | 'card'
        | 'mm'
        | 'yy'
        | 'cvv'
        | 'zip'
        | 'checksum'
      >,
      default: 'text',
    },
    isValid: {
      type: Boolean,
      default: true,
    },
    validate: {
      type: Boolean,
      default: true,
    },
    onlynumb: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    label: String,
    name: String,
    placeholder: String,
    maxlength: [String, Number],
    errorText: String,
    autocomplete: String,
    customMask: String,
  },
  emits: ['update:value', 'focus', 'change'],
  setup(__props, { expose, emit }) {

const props = __props

  

  

  const focused = ref<boolean>(false);
  // TODO: separate refs of input and TheMask
  const input = ref<HTMLInputElement>(null);

  const inputValue: WritableComputedRef<string> = computed({
    get() {
      return props.value;
    },
    set(val) {
      emit('update:value', val);
    },
  });

  const inputSetting = computed(() => {
    if (props.customMask) {
      return { mask: props.customMask };
    }

    switch (props.type) {
      case 'datepicker':
        return {
          mask: '####-##-##',
        };
      case 'card':
        return {
          mask:
            inputValue.value.startsWith('34') ||
            inputValue.value.startsWith('37')
              ? '#### ###### #####'
              : '#### #### #### #### ###',
        };
      case 'mm':
        return {
          mask: '##',
        };
      case 'yy':
        return {
          mask: '##',
        };
      case 'cvv':
        return {
          mask: '####',
        };
      case 'zip':
        return {
          mask: '#####',
        };
      case 'checksum':
        return {
          mask: '#.##',
        };
      default:
        return {
          mask: '',
        };
    }
  });

  function focusin() {
    focused.value = true;
    emit('focus');
  }

  function focus() {
    if (input.value?.focus) {
      input.value?.focus();
      return;
    }

    // TODO: separate masked and default input refs
    if ((input.value as any)?.$refs?.input?.focus) {
      (input.value as any).$refs.input.focus();
    }
  }

  function onChange(event: Event) {
    emit('change', event);
  }

  function phoneKeyupHandle(event: KeyboardEvent) {
    let key = (event as any).key;
    if (!isNaN(parseFloat(key)) && isFinite(key) && key != 'Backspace') {
      return true;
    } else {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  }

  expose({
    input,
    focus,
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!!__props.label)
      ? (_openBlock(), _createBlock(LabelComponent, {
          key: 0,
          inputName: __props.name
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.label), 1)
          ]),
          _: 1
        }, 8, ["inputName"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["input-container", [
        { 'has-error': __props.validate && !!__props.errorText },
        { 'not-valid': !__props.isValid },
        { readonly: __props.readonly },
      ]]),
      "data-error": __props.errorText
    }, [
      (_unref(inputSetting).mask)
        ? (_openBlock(), _createBlock(_unref(TheMask), {
            key: 0,
            class: "regular black border-radius",
            ref_key: "input",
            ref: input,
            name: __props.name ? __props.name : '',
            type: __props.type ? __props.type : 'text',
            maxlength: __props.maxlength,
            placeholder: __props.placeholder,
            mask: _unref(inputSetting).mask,
            onFocus: focusin,
            pattern: "[0-9]*",
            inputmode: "numeric",
            autocomplete: __props.autocomplete ? __props.autocomplete : '',
            value: _unref(inputValue),
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(inputValue) ? (inputValue).value = $event : null))
          }, null, 8, ["name", "type", "maxlength", "placeholder", "mask", "autocomplete", "value"]))
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            class: "regular black border-radius",
            ref_key: "input",
            ref: input,
            type: __props.type ? __props.type : 'text',
            name: __props.name ? __props.name : undefined,
            onKeypress: _cache[1] || (_cache[1] = ($event: any) => (__props.onlynumb ? phoneKeyupHandle : null)),
            maxlength: __props.maxlength,
            placeholder: __props.placeholder,
            readonly: __props.readonly,
            onFocus: focusin,
            onChange: onChange,
            pattern: __props.onlynumb ? '[0-9]*' : undefined,
            inputmode: __props.onlynumb ? 'numeric' : 'text',
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(inputValue) ? (inputValue).value = $event : null))
          }, null, 40, _hoisted_3)), [
            [_vModelDynamic, _unref(inputValue)]
          ])
    ], 10, _hoisted_2)
  ]))
}
}

})